/*
 * TunePad
 * Northwestern University
 * michael-horn@northwestern.edu
 *
 * This project was funded by the National Science Foundation (grant DRL-1612619).
 * Any opinions, findings and conclusions or recommendations expressed in this
 * material are those of the author(s) and do not necessarily reflect the views
 * of the National Science Foundation (NSF).
 */
import styles from './output.module.css' with { type: 'css' };
import html from './output.module.html';


/**
 * <python-output>{ output }</python-output>
 */
export class PythonOutput extends HTMLElement {

    static DefineElement() {
        if (customElements.get('python-output') === undefined) {
            customElements.define("python-output", PythonOutput);
        }
    }

    static observedAttributes = [ ];

    /// all of the HTML elements for the instrument are contained within a shadow DOM
    private root : ShadowRoot;

    constructor() {
        super();
        this.root = this.attachShadow({ mode: 'open' });
        this.root.adoptedStyleSheets.push(styles);
        this.root.innerHTML = html;
    }

    connectedCallback() {
        const output = this.root.host.innerHTML.trim();
        const count = output.split('\n').length;
        this.setHTML('#output-container', output);
        this.setHTML('.counter', `${count}`);

        this.root.querySelector('.toolbar')?.addEventListener('pointerup', (evt) => {
            this.toggleClass('#expand-button', 'hidden');
            this.toggleClass('#collapse-button', 'hidden');
            this.toggleClass('#output-container', 'hidden');
        });
    }

    disconnectedCallback() { }

    private setHTML(selector : string, html : string) {
        const e = this.root.querySelector(selector);
        if (e) e.innerHTML = html;
    }

    private toggleClass(selector : string, className : string) {
        const e = this.root.querySelector(selector);
        if (e) e.classList.toggle(className)
    }
}

